export enum FilterOperator{
  Contains,
  Equal,
  NotEqual,
  LessThan,
  LessThanOrEqual,
  GreaterThan,
  GreaterThanOrEqual,
  InList,
  NotInList,
  InBetween,
}

export enum SortOperator {
  ASCENDING,
  DESCENDING
}
